"use client";

import Script from "next/script";
import { GTM_ID, PAGE_ANALYTICS_READY_EVENT } from "@/utils/gtm.utils";

export function Analytics() {
  if (!GTM_ID) {
    return;
  }

  return (
    <>
      <noscript>
        <iframe
          height="0"
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          style={{ display: "none", visibility: "hidden" }}
          title="Google Tag Manager"
          width="0"
        />
      </noscript>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){
              w[l]=w[l]||[];
              var parts=w.location.pathname.split('/').filter(Boolean);
              // The canonical PDP emits readiness; the legacy article-code URL
              // redirects without it, so delay GTM rather than view that URL.
              // Keep this paired with product-page-analytics.tsx.
              var needsMetadata=(parts[2]==='product' && parts.length>=4) ||
                (parts[2]==='company' && parts[3]==='newsletter' && parts.length===4);
              var started=false;
              var fallbackTimer;
              function start(){
                if(started) return;
                started=true;
                w.clearTimeout(fallbackTimer);
                w.removeEventListener('${PAGE_ANALYTICS_READY_EVENT}',start);
                w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
                var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),
                    dl=l!='dataLayer'?'&l='+l:'';
                j.async=true;
                j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
                f.parentNode.insertBefore(j,f);
              }
              if(needsMetadata && !w[l].some(function(item){return item && item.event==='dataLayer_ready';})){
                w.addEventListener('${PAGE_ANALYTICS_READY_EVENT}',start);
                // Error routes still need GTM for CMP; successful pages
                // normally emit readiness well before this fallback.
                fallbackTimer=w.setTimeout(start,10000);
              } else {
                start();
              }
            })(window,document,'script','dataLayer','${GTM_ID}');
          `,
        }}
        id="gtm-script"
        strategy="afterInteractive"
      />
    </>
  );
}
